import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axios from '@/app/axios'
import debounce from 'lodash/debounce'
import { Debouceable } from '@/app/types/debouncable'
import NodeEntity from '@/common/models/node-entitiy'
import Responses from '@/app/utils/responses'

@Component
export default class ConnectionInput extends Vue {

  @Prop({ required: true })
  private projectId!: string

  @Prop({ required: true })
  private container!: NodeEntity

  @Prop({ required: true })
  private entityLabel!: string

  @Prop({ required: true })
  private entitiesLabel!: string

  @Prop({ required: true })
  private url!: string

  @Prop({ default: 3 })
  private counter!: boolean | number | string

  @Prop({ required: true })
  private tooltipMessage!: string

  @Prop({ default: 0 })
  private minElements!: number

  @Prop({ default: false })
  private archived!: boolean

  private items: any[] = []
  private model: any[] = []
  private search = ''
  private loading: boolean = false

  private debouncedLoad: Debouceable = null

  @Watch('container', { deep: true })
  private containerChanged(val: NodeEntity, old: NodeEntity) {
    if (val.id !== old.id) {
      this.loadSelection()
    }
  }

  @Watch('search')
  private async searchUpdated(val: string, old: string) {
    if (val !== old) {
      await this.findMatchesDebounced()
    }
  }

  private async loadSelection() {
    const res = await axios.get<NodeEntity[]>(`${this.url}/${this.container.id}`)
    this.model = Responses.list(res)
  }

  private async findMatchesDebounced() {
    if (this.debouncedLoad) {
      this.debouncedLoad.cancel()
    }
    this.debouncedLoad = debounce(async () => this.findMatches(this.search), 500)
    this.debouncedLoad()
  }

  private async findMatches(text: string = '') {
    this.loading = true
    const matches = await this.fetchMatches(text)
    this.items = []
    this.items.push({ header: 'Vervollständigung' })
    this.items.push(...matches)
    // this.items.push({ header: `Häufig verwendete ${this.entitiesLabel}` })
    this.loading = false
  }

  private async fetchMatches(text: string = '') {
    const res = await axios.post<NodeEntity[]>(this.url, {
      projectId: this.projectId,
      text,
    })
    return Responses.list(res)
  }

  private async onInput(val: any) {
    const newModel = val.filter((v: any) => typeof v !== 'string')
    const sel = newModel.map((v: any) => ({ id: v.id, name: v.name }))
    await this.updateSelection(sel)
    this.model = newModel
    this.$emit('input')
  }

  private async updateSelection(items: any) {
    const res = await axios.post<NodeEntity[]>(`${this.url}/update`, {
      containerId: this.container.id,
      items,
    })
    return Responses.list(res)
  }

  private highlight(v: string) {
    const regex = new RegExp(`(${this.search})`, 'ig')
    return v.replace(regex, '<strong>$1</strong>')
  }

  private mounted() {
    this.loadSelection()
  }
}
